import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Root } from './MatterList.css';
import * as reducer from './MatterList.reducer';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Paper, Table, TableHead, TableRow, TableCell, TableBody, Dialog, Breadcrumbs, Link, Typography, TableFooter, TablePagination } from '@material-ui/core';
import AddMatter from './components/AddMatter';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { roleStr, roleName, roleInfo } from '../../common/common'
import { timeFormat } from '../../common/utils'
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
const ADMIN = "admin";
const DEPT = "dept_manager";
const TEAM = "team_leader";
class MatterList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            matters: [],
            caseNumber: "",
            clientEmail: "",
            open: false,
            dialogState: ADD,
            dialogTitle: "",
            crtMatterObj: null,

            page_index: 1,
            page_size: 5,
            total_items: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false,
        }
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleAddMatter = this.handleAddMatter.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            matters,
            caseNumber,
            clientEmail,
            page_index,
            page_size,
            total_items,
            showToast,
            toastMsg,
            toastState,
            showAlert,
        } = this.state;
        const delBtn = (row) => {
            if (roleName === ADMIN) {
                return <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
            }
        }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle title="All Matters" subtitle="MANAGEMENT"></PageTitle>
                    </div>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleAddMatter}>CREATE MATTER</Button>
                    </div>
                    <Dialog maxWidth={false} open={this.state.open}>
                        <AddMatter
                            handleCreate={this.handleCreate}
                            handleCancel={this.handleCancel}
                            title={this.state.dialogTitle}
                            data={this.state.crtMatterObj}
                            state={this.state.dialogState}
                        ></AddMatter>
                    </Dialog>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Matter Number</TableCell>
                                <TableCell>Matter Name</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Creator</TableCell>
                                <TableCell>Originating Attorney</TableCell>
                                <TableCell>Team</TableCell>
                                <TableCell>Office</TableCell>
                                <TableCell>Modified Time</TableCell>
                                <TableCell>Create Time</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {matters.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.number}
                                    </TableCell>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{this.clientName(row.case)}</TableCell>
                                    <TableCell>{row.handler ? row.handler[0].user.username : ""}</TableCell>
                                    <TableCell>{row.handler ? row.handler[0].user.first_name : ""} {row.handler ? row.handler[0].user.last_name : ""}</TableCell>
                                    <TableCell>{row.handler ? row.handler[0].team.name : ""}</TableCell>
                                    <TableCell>{row.handler ? row.handler[0].team.dept_info.office : ""}</TableCell>
                                    <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            {delBtn(row)}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {matters.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={12}
                                    count={total_items}
                                    page={matters.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this matter?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        this.getMatters();
    }
    handleAddMatter() {
        this.openDialog("CREATE MATTER", ADD);
    }
    handleView(e, obj) {
        this.setState(() => ({
            crtMatterObj: obj
        }))
        this.openDialog("MATTER INFO", VIEW);
    }
    handleEdit(e, obj) {
        this.setState(() => ({
            crtMatterObj: obj
        }))
        this.openDialog("EDIT MATTER INFO", EDIT);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            crtMatterObj: obj,
            showAlert: true
        }))
    }
    //关闭dialog
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCreate(obj) {
        const { dialogState, crtMatterObj } = this.state;
        if (dialogState === ADD) {
            this.createMatters(obj);
        } else if (dialogState === EDIT) {
            let matter_id = crtMatterObj.id;
            this.updateMatters(matter_id, obj);
        }
    }
    //取消dialog
    handleCancel() {
        this.closeDialog();
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getMatters();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getMatters();
        });
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        const { crtMatterObj } = this.state;
        let matter_id = crtMatterObj.id;
        this.delMatters(matter_id);
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            crtMatterObj: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    membersNum(arr) {
        if (arr) {
            return arr.length;
        }
    }
    getMatters() {
        const { page_index, page_size } = this.state;
        const params = {
            page_index,
            page_size
        }
        this.getMatterList(params);
    }
    clientName(caseObj) {
        if (caseObj) {
            const client = caseObj.client;
            if (client.individual) {
                return client.individual.first_name + " " + client.individual.last_name;
            } else if (client.corporation) {
                return client.corporation.name;
            } else {
                return "--";
            }
        } else {
            return "--";
        }
    }
    //-----------request-------------
    getMatterList(params) {
        console.log(params)
        instance.get(BASE_URL + roleStr() + '/matters', { params }).then((res) => {
            const value = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(value)
            let matters = [];
            if (value) {
                matters = value;
            }
            this.setState(() => ({
                matters,
                page_size,
                total_items
            }))
        })
    }
    createMatters(obj) {
        let params = {
            case_id: obj.case_id,
            number: obj.number,
            name: obj.name,
            note: obj.note,
            handlers: obj.handlers
        }
        instance.post(BASE_URL + "" + roleStr() + "/matters", params).then((res) => {
            this.showToast("Added successfully", "success");
            this.getMatters();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateMatters(matter_id, obj) {
        let params = {
            case_id: obj.case_id,
            number: obj.number,
            name: obj.name,
            note: obj.note,
        }
        instance.put(BASE_URL + "" + roleStr() + "/matters/" + matter_id, params).then((res) => {
            this.showToast("Successfully modified", "success");
            this.getMatters();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delMatters(matter_id) {
        instance.delete(BASE_URL + "" + roleStr() + "/matters/" + matter_id).then((res) => {
            console.log("del", res)
            this.showToast("Successfully deleted", "success");
            this.getMatters();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

// store映射
const mapStateToProps = (state) => {
    return {
        matters: state.getIn(['matter', 'matters'])
    }
}
const mapDispathToProps = (dispath) => {
    return {
        getMatters: (params) => {
            dispath(reducer.getMatters(params));
        },
        setMatters: (params) => {
            dispath(reducer.setMatters(params));
        }
    }
}

export default connect(mapStateToProps, mapDispathToProps)(withRouter(MatterList));